import { Grid, Icon, ListItemIcon, ListItemText } from "@mui/material";


import SoftTypography from "components/SoftTypography";
import { useCardroomContext } from "features";

import { useState } from "react";

import Card from "@mui/material/Card";
import RebateScheduleEditor from "layouts/Club/components/RebateFees/Editor";
import PlayerRebateSelector from "layouts/Club/components/RebateFees/Selector";



const PlayerRebateEditor = ({ cardroom, agency, club, book }) => {

    const [context, actions, features] = useCardroomContext(cardroom);

    function canManageRebateSchedule() {
        if ((!agency && !club && !book) || !cardroom || !context) return false;

        if (!context.isEnabled(features.club.reporting.playerReport)) return false;

        return context.isAllowed(actions.cardroom.fees.rebate.edit);
    }


    const addSchedulePlaceHolder = canManageRebateSchedule() ? { id: null, name: "New Schedule" } : null;

    const [currentFeeSchedule, setCurrentFeeSchedule] = useState(null);
    const [reloadSchedulesNeeded, setReloadSchedulesNeeded] = useState(false);

    function onFeeScheduleChanged(item) {
        //if (item && item.id === "403") {
        //    item = null;
        //}

        if (item) {
            setReloadSchedulesNeeded(false);
        }

        setCurrentFeeSchedule(item);

    }

    function onScheduleEditDone(canceled) {
        setCurrentFeeSchedule(null);
        setReloadSchedulesNeeded(true);
    }

    function buildListItem(item) {
        if (item.id) {
            if (item.id === "403") {
                return <>
                    <ListItemIcon style={{ minWidth: "32px" }}>
                        <Icon color={"error"}>block</Icon>
                    </ListItemIcon>
                    <ListItemText><SoftTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        textTransform="capitalize">
                        {item.name}
                    </SoftTypography></ListItemText></>;
            }
            else {
                return <ListItemText><SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="capitalize">
                    {item.name}
                </SoftTypography></ListItemText>;
            }
        }
        else {
            return <>
                <ListItemIcon style={{ minWidth: "32px" }}>
                    <Icon>add</Icon>
                </ListItemIcon>
                <ListItemText><SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="capitalize">
                    {item.name}
                </SoftTypography></ListItemText></>;
        }
    }

    return <Grid width="100%" xs={12}>
        <Grid container xs={12}>
            <Grid item xs={4} p={2}>
                <PlayerRebateSelector cardroom={cardroom} agency={agency} club={club} book={book} emptyValue={addSchedulePlaceHolder}
                    onSelectionChanged={onFeeScheduleChanged} onBuildListItem={buildListItem} type="list" reload={reloadSchedulesNeeded} maxHeight="375px" />
            </Grid>
            <Grid item xs={8}> <Card style={{ overflow: "auto" }}>
                {currentFeeSchedule ?
                    <RebateScheduleEditor cardroom={cardroom} agency={agency} club={club} book={book} schedule={currentFeeSchedule} dense={true} onClose={onScheduleEditDone} />
                    :
                    <Card sx={{ height: 375 }}>
                        <Grid container xs={12} justifyContent="center" alignItems="center">
                            <Grid item xs={12} textAlign={"center"}>

                                <SoftTypography
                                    component="h5"
                                    variant="caption"
                                    color="info">
                                    Select rebate schedule from the list or tap "add new" to create a new schedule
                                </SoftTypography>

                            </Grid>
                        </Grid>
                    </Card>
                }</Card>
            </Grid>
        </Grid>
    </Grid>;
};

export default PlayerRebateEditor;